import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 49 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_769_6807)" }, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip1_769_6807)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M31.56 17.04 27.47 6h-5.74l-4.09 11.04L7.6 20.76v6.48l10.04 3.72L21.73 42h5.74l3.11-8.4-2.12-5.76-.02.01-3.84 10.39-3.84-10.39L10.36 24l10.4-3.85L24.6 9.76l3.84 10.39L38.84 24l-10.38 3.84 5.12 2.37 9.02-3.34v-5.74z"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }